import React from 'react';
import classNames from 'classnames';

import 'components/person/person.scss';
interface PersonProps {
  gender?: string;
  selected?: boolean;
  onClick?: (event: React.SyntheticEvent<any>) => void;
}

const defaultProps: PersonProps = {
  gender: 'm',
  selected: false
};

const Person: React.SFC<PersonProps> = props => (
  <div
    onClick={props.onClick}
    className={classNames('c-person', {
      'is-selected': props.selected
    })}
  >
    <img
      src={`/images/svg/person/${
        props.gender === 'female' ? 'girl.svg' : 'boy.svg'
      }`}
    />
  </div>
);

Person.defaultProps = defaultProps;

export default Person;



// WEBPACK FOOTER //
// ./src/components/person/person.tsx